import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DataTableComponent } from '../data-table/data-table.component';
import { SnackbarService } from '../snackbar/snackbar.service';
import { SecurityStockCesService } from '../../../configuration/service/security-stock-ces.service';
import { SecurityStockUpdateResponse } from '../../../core/models/configuration-system/centralized-security-stock/security-stock-update-response.model';
import { UpdateSecurityStockByHierarchyComponent } from '../../../configuration/security-stock-ces/update-security-stock-by-hierarchy/update-security-stock-by-hierarchy.component';
import { ModalConfirmComponent } from '../modal-confirm/modal-confirm.component';

@Component({
  standalone: false,
  selector: 'app-modal-list-ces',
  templateUrl: './modal-list-ces.component.html',
  styleUrls: ['./modal-list-ces.component.scss']
})
export class ModalListCesComponent implements OnInit {
  @ViewChild(DataTableComponent) childDataTable: DataTableComponent;

  selectedIndex: number | null = null;  

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ModalListCesComponent>,
    private securityStockCesService: SecurityStockCesService,
    private snackbarService: SnackbarService,
    @Inject(MAT_DIALOG_DATA) public list: any
  ) { }

  ngOnInit() { 
    this.childDataTable?.onUpdateCheckboxEnabled(true);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSelect(index: number) {
    if (this.selectedIndex === index) {
      this.selectedIndex = null; // deseleccionar
    } else {
      this.selectedIndex = index;
    }
  }

  toggleEnable(item: any): void {
    item.enabled = !item.enabled;
    if (!item.enabled) {
      item.isEditing = false;
    }
  }

  enableEdit(item: any): void {
    item.isEditing = true;
  }

  cancelEdit(item: any): void {
    item.isEditing = false;
  }

  saveItem(item: any): void {
    item.isEditing = false;
    // Aquí podrías emitir un evento o hacer algo con el valor actualizado
  }

  removeField(index: number): void {
    const confirmDelete = window.confirm('¿Estás seguro de que deseas eliminar esta fila?');

    if (confirmDelete) {

      // Si el eliminado era el seleccionado, reseteamos el estado
      if (this.selectedIndex === index) {
        this.selectedIndex = null;
      } else if (this.selectedIndex > index) {
        // Ajustamos el índice si eliminamos un item antes del seleccionado
        this.selectedIndex--;
      }
    }
  }

  actionHeader(event) {
    if (event && event.action && event.data) {
      switch (event.action) {
        case 'edit':
          this.showUpdateDialog(event.data);
          break;
        case 'trash':
          this.removeSecurityStock(event.data);
          break;
      }
    }
  }

  
  removeSecurityStock(data: any[]) {
    this.dialog
      .open(ModalConfirmComponent, {
        data: "deleteItem",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((state) => {
        if (state) {
          this.updateSecurityStockById({
            securityStock: data[0].securityStock,
            id: data[0].id
          }, false);
        }
      });
    }

  showUpdateDialog(info = null) {
    const dialog = this.dialog.open(UpdateSecurityStockByHierarchyComponent, {
      data: info,
      width: '300px',
      maxWidth: '80vw',
      disableClose: true
    });

    dialog.afterClosed()
      .subscribe((data) => {
        if (data && data.securityStockForm) {
            this.updateSecurityStockById(data.securityStockForm, true);
        }
      });
  }

  updateSecurityStockById(securityStockForm: any, isActive: boolean) {
    const request: any = {
      isActive: isActive!=null? isActive: true,
      securityStock: securityStockForm.securityStock
    }
    this.securityStockCesService.updateSecurityStockById(request, securityStockForm.id).subscribe(
      (res: SecurityStockUpdateResponse) => {
        if (res && res.success && res.data && res.data.securityStock == request.securityStock) {
          this.dialogRef.close({ securityStockUpdated: true });
          this.snackbarService.show("Se actualizó la configuración del stock exitosamente", "success")
        }
      }
    );
  }
}

